export default {
  noItemsToDisplay: 'There is no info to display yet',
};
